'use strict';

const DEFAULT_USER_ID = 'U26a97795b8792b3a6371c6f147c798eb';

function initLiff() {
  return fetch('https://api-dot-tueyhom.df.r.appspot.com/getLiffId')
    .then(res => res.json()).then(function (json) {
      return liff
        .init({
          liffId: json.id
        }).then(function () {
          if (!liff.isLoggedIn()) {
            if (process.env.DEV) {
              liff.login({ redirectUri: "http://localhost:5000" });
            } else {
              liff.login();
            }
          }

          return liff;
        });
    });
}

var liffPromise;
async function getLiff() {
  if (liffPromise == null) {
    liffPromise = new Promise(function (resolve, reject) {
      initLiff().then(function () {
        resolve(liff);
      }).catch(function (e) {
        reject();
      });
    });
  }
  return liffPromise;
}

var liffProfilePromise;
async function getLiffProfile() {
  if (liffProfilePromise == null) {
    liffProfilePromise = new Promise(function (resolve, reject) {
      getLiff().then(function (liff) {
        liff.getProfile().then((profile) => resolve(profile));
      }).catch(function (error) {
        reject(error);
      });
    });
  }
  return liffProfilePromise;
};

async function getLiffLanguage() {
  return getLiff().then(() => liff.getLanguage());
}

export { getLiffProfile, getLiffLanguage, DEFAULT_USER_ID }